
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "tabs",
  props: {
    typeList: [],
    defaultValue: Number,
    width: String,
  },
  emits: ["tabsType"],
  setup(props, { emit }) {
    const typeid = ref(props.defaultValue);
    const typechange = (type: number) => {
      typeid.value = type;
      emit("tabsType", type);
    };
    return { typechange, typeid };
  },
});
